import { z } from 'zod';
/** Admin "upload logo" payload. Mirrors Admin\LogoController::store(). */
export const logoCreateSchema = z.object({
    name: z.string().min(1).max(255),
    path: z.string().min(1),
    version: z.string().nullable().optional(),
});
export const logoFileSchema = z.object({
    sizeKb: z.number().max(2048, 'Logo must be <= 2048 KB'),
    type: z.enum(['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml']),
});
//# sourceMappingURL=logo.js.map